import Galery from '../Galery'
import Hero from '../Hero'
import './Home.css'

const Home = () => {
  return (
    <div>
        <Hero />
        <Galery />
    </div>
  )
}

export default Home